import { restClient } from '@/Core'

/** Видалити корінь кошика назавжди (незворотно): `DELETE /services/disk/trash/{uuid}`. */
export const PurgeDiskNodeTask = async (uuid: string): Promise<void> => {
    await restClient.delete(`/services/disk/trash/${encodeURIComponent(uuid)}`)
}
